export const DARK_MODE_SELECTOR = ".p-theme-dark";

export function applyThemePreference(
  enabled,
  { root = document.documentElement, storage = localStorage } = {}
) {
  const isDark = Boolean(enabled);
  root.classList.toggle(DARK_MODE_SELECTOR.slice(1), isDark);
  storage.setItem("darkMode", String(isDark));
}
